import { ModeOutlined, UploadFileOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { TextField, useMediaQuery } from '@mui/material';
import ProfileCard from '../ProfileCard/ProfileCard';
import colors from '../../../../scss/colors';
import { MyUploadedCV } from '../../../../Components/pages/myProfile/components';
import MainButton from '../../../../Components/common/buttons/MainButton';
import { buttonVariants } from '../../../../Components/common/buttons/types';
import NudgeIcon from '../../../../Components/common/CustomIcon/CustomIcon';
import BaseModal from '../../../../Components/common/ModalWindows/BaseModal';

function AboutComponent({
  description,
  setDescription,
  profile,
  isCompleted,
  setIsCompleted,
  onEdit,
  shouldShowNudge,
  setEditSummary = () => {},
  editSummary,
  handleUpdateSummary,
  summaryServerVersion
}) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width: 767px)');
  return (
    <ProfileCard customClass="md:gap-4">
      <div className="flex flex-row justify-between items-start w-full">
        <h4 className="!text-base sm:!text-xl !font-medium">Summary</h4>
        <div className="flex gap-3">
          <NudgeIcon
            iconComponent={<ModeOutlined />}
            onClick={onEdit}
            nudge={shouldShowNudge}
            tooltipText="Please complete the section"
            iconColor={colors.NAVY_BLUE}
          />
        </div>
      </div>
      <div className="flex flex-row justify-between items-start w-full text-sm md:text-base mb-4">
        {summaryServerVersion || <span className="text-gray-400">{t('dashboard.profile.aboutPlaceholder')}</span>}
      </div>
      {isCompleted ? (
        <MyUploadedCV cvName={profile?.CvName} />
      ) : (
        <MainButton
          outlined
          variant={buttonVariants.SECONDARY}
          rounded
          size="small"
          action={() => setIsCompleted(false)}
          sx={{
            gap: '10px',
            fontWeight: '500'
          }}
        >
          <UploadFileOutlined />
          {t('common.general.extractprofile')}
        </MainButton>
      )}
      <BaseModal
        title={t('dashboard.modal.edit.summary')}
        open={editSummary}
        closeHandler={() => {
          setEditSummary(false);
        }}
        confirmHandler={handleUpdateSummary}
        pending={profile?.summaryPending}
      >
        <TextField
          sx={{ marginTop: '30px' }}
          fullWidth
          label={t('dashboard.modal.edit.summaryPlaceholder')}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={isMobile ? 15 : 6}
        />
      </BaseModal>
    </ProfileCard>
  );
}

export default AboutComponent;
